import { useState, useEffect } from "react";

import { dispatch, getState } from "../../state/store";
import { setAppVersion } from "../../state/ducks";
import { selectAppVersion } from "../../state/selectors";

import { applicationService, log } from "../../services";

import AppVersionModal from "./AppVersionModal";

const VERSION_CHECK_INTERVAL = 60 * 60 * 1000; // 1 hour

const getAppVersion = async () => {
  try {
    const fileAppVersion = await applicationService.getAppVersion();
    return fileAppVersion;
  } catch (e) {
    log.error("Failed to load web app version", e);
  }
};

const AppVersionDetector = () => {
  const [versionModalActive, setVersionModalActive] = useState(false);

  let intervalId = null;

  useEffect(() => {
    saveAppVersion();
    restarVersionCheckInterval();

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const saveAppVersion = async () => {
    const fileAppVersion = await getAppVersion();
    if (fileAppVersion) {
      dispatch(setAppVersion(fileAppVersion));
    }
  };

  const compareAppVersions = (fileAppVersion) => {
    const appVersion = selectAppVersion()(getState());

    if (fileAppVersion !== appVersion) {
      setVersionModalActive(true);
    }
  };

  const restarVersionCheckInterval = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }

    intervalId = setInterval(async () => {
      const fileAppVersion = await getAppVersion();
      if (fileAppVersion) {
        compareAppVersions(fileAppVersion);
      }
    }, VERSION_CHECK_INTERVAL);
  };

  const onRefresh = () => {
    setVersionModalActive(false);
    window.location.reload();
  };

  return (
    <AppVersionModal
      active={versionModalActive}
      setActive={setVersionModalActive}
      onRefresh={onRefresh}
    />
  );
};

export default AppVersionDetector;
